import { documentItemFromDocument } from '@/services/documents/documentItemMapper'

function artifactSizeLabel(status) {
  if (status === 'reserving') return 'Uploading…'
  if (status === 'uploaded') return 'Saved'
  if (status === 'processing') return 'Processing…'
  if (status === 'failed') return 'Failed'
  return 'Ready'
}

export function threadArtifactFromRow(row = {}) {
  const item = documentItemFromDocument({
    id: row.id,
    name: row.title,
    status: row.status,
    updatedAt: row.created_at,
  })
  return {
    ...item,
    sizeLabel: artifactSizeLabel(row.status),
    artifactId: String(row.id ?? ''),
    documentId: row.document_id ? String(row.document_id) : null,
    kind: String(row.kind ?? 'other'),
    sourceMessageId: row.source_message_id
      ? String(row.source_message_id)
      : null,
    producedMessageId: row.produced_message_id
      ? String(row.produced_message_id)
      : null,
  }
}
